/** Base URL Express backend (tanpa trailing slash). */
export const API_BASE = (process.env.REACT_APP_API_URL ?? "http://localhost:3000").replace(/\/$/, "");
